import { useContext } from "react";
import { Box, Tooltip } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { GlobalContext } from "../../globalContext";
import GlobalFilterSelect from "./../filters/GlobalFilterSelect";

import { shouldDisableGlobalFilter } from "../../utils/utils";

const toolTipText =
  "Global filter is disabled on edit and create screens to prevent object ID conflicts. You can change it on the homepage or overview screens.";

export const GlobalFiltersContainer = () => {
  const { globalFilters, setGlobalObjectFilter } = useContext(GlobalContext);
  const history = useHistory();
  const location = useLocation();

  // Disable global filter on create and edit screens to prevent object ID mismatches
  const isDisabled = shouldDisableGlobalFilter(location.pathname);

  const handleFieldChange = (e, value) => {
    const globalFilter = {
      columnField: "object_id",
      operatorValue: "contains",
      value: value === null ? "" : value,
      init: false,
    };

    setGlobalObjectFilter(globalFilter);

    // Enforce URL format when global filter is selected
    if (value) {
      const currentParams = new URLSearchParams(location.search);
      currentParams.set("objectId", value);
      history.replace(`${location.pathname}?${currentParams.toString()}`);
    } else {
      // Remove objectId from URL when filter is cleared
      const currentParams = new URLSearchParams(location.search);
      currentParams.delete("objectId");
      const newSearch = currentParams.toString();
      history.replace(
        `${location.pathname}${newSearch ? "?" + newSearch : ""}`
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderRadius: 1,
        paddingRight: "1rem",
        height: "100%",
      }}
      data-testid='global-filters-container'
    >
      <Tooltip title={isDisabled ? toolTipText : ""} placement='bottom' arrow>
        <span
          style={{
            display: "inline-block",
            width: "100%",
            height: "100%",
          }}
        >
          <GlobalFilterSelect
            onChange={handleFieldChange}
            id='globalObjectFilter'
            variant='outlined'
            label='Currently working on'
            size='small'
            data-testid='global-filter-field'
            value={globalFilters?.value || null}
            disabled={isDisabled}
            sx={{
              height: "100%",
            }}
            inputProps={{
              sx: {
                height: "100%",

                "& .MuiInputBase-root": {
                  width: 300,
                  height: "100%",
                  color: "#FFFFFF",
                },
                "& .MuiInputBase-root.Mui-disabled .MuiInputBase-input": {
                  WebkitTextFillColor: "#FFFFFF !important",
                  cursor: "not-allowed !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FFFFFF !important",
                  color: "#FFFFFF",
                },
                "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "2px",
                },
                "& .MuiInputLabel-root": {
                  top: "50%",
                  transform: "translate(14px, -50%) scale(1)",
                  color: "#FFFFFF",
                  lineHeight: 1,
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: "#FFFFFF !important",
                },
                "& .MuiFormLabel-filled": {
                  transform: "translate(14px, -5px) scale(0.75)",
                  top: 0,
                },
                "& .MuiInputLabel-root.Mui-focussed": {
                  color: "#FFFFFF",
                  lineHeight: 1,
                },
                "& .MuiAutocomplete-endAdornment svg": {
                  fill: "#FFFFFF",
                },
                "& .Mui-disabled .MuiAutocomplete-endAdornment": {
                  display: "none",
                },
              },
            }}
          />
        </span>
      </Tooltip>
    </Box>
  );
};
